module.exports = __webpack_public_path__ + "img/approve_img.85198f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/approve_img.png
// module id = tapz
// module chunks = 1 87